import { render } from "./CreateAppointmentDialog.vue?vue&type=template&id=edcaa336"
import script from "./CreateAppointmentDialog.vue?vue&type=script&lang=js"
export * from "./CreateAppointmentDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__